import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressMultilingualSitetranslatorV2SiteTranslatorV2Url(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'editor._base_domain_': [
      {
        srcPath: '/_api/site-translator',
        destPath: '',
      },
      {
        srcPath: '/_api/site_translator/v2/properties',
        destPath: '/v2/properties',
      },
      {
        srcPath: '/_api/site_translator/v2/translate',
        destPath: '/v2/translate',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/site-translator',
        destPath: '',
      },
      {
        srcPath: '/_api/site_translator/v2/properties',
        destPath: '/v2/properties',
      },
      {
        srcPath: '/_api/site_translator/v2/translate',
        destPath: '/v2/translate',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/site-translator',
        destPath: '',
      },
      {
        srcPath: '/_api/site_translator/v2/properties',
        destPath: '/v2/properties',
      },
      {
        srcPath: '/_api/site_translator/v2/translate',
        destPath: '/v2/translate',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/site-translator',
        destPath: '/api',
      },
      {
        srcPath: '/_api/site-translator/v2/properties',
        destPath: '/v2/properties',
      },
      {
        srcPath: '/_api/site-translator/v2/translate',
        destPath: '/v2/translate',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/multilingual/v2/site-translator',
        destPath: '/v2',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/site_translator/v2/properties',
        destPath: '/v2/properties',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_multilingual_site-translator';

/** Start a task to auto-translate all site content that hasn't been translated yet */
export function translateSite(payload: object): RequestOptionsFactory<any> {
  function __translateSite({ host }: any) {
    const metadata = {
      entityFqdn:
        'wix.multilingual.sitetranslator.v2.site_translatable_properties',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.multilingual.sitetranslator.v2.SiteTranslatorV2.TranslateSite',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressMultilingualSitetranslatorV2SiteTranslatorV2Url({
        protoPath: '/v2/translate',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __translateSite;
}

/** Receive the site's translation status */
export function getSiteTranslatablesProperties(
  payload: object
): RequestOptionsFactory<any> {
  function __getSiteTranslatablesProperties({ host }: any) {
    const metadata = {
      entityFqdn:
        'wix.multilingual.sitetranslator.v2.site_translatable_properties',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.multilingual.sitetranslator.v2.SiteTranslatorV2.GetSiteTranslatablesProperties',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressMultilingualSitetranslatorV2SiteTranslatorV2Url({
        protoPath: '/v2/properties',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __getSiteTranslatablesProperties;
}
